import type { HTMLAttributes, ReactNode } from 'react';
import type { SpaceStep } from './Stack.js';

export interface GridProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Mindestbreite einer Spalte. Das Raster legt selbst fest, wie viele
   * hineinpassen — es gibt bewusst keine feste Spaltenzahl.
   */
  min?: 'sm' | 'md' | 'lg';
  gap?: SpaceStep;
  children: ReactNode;
}

/**
 * Raster, das sich selbst umbricht.
 *
 * Statt Haltepunkte je Seite zu pflegen, gibt jede Flaeche nur ihre
 * Mindestbreite an; `auto-fit` und `minmax` erledigen den Rest. Damit ist
 * jede Rasterflaeche automatisch bis 360 px hinunter brauchbar, ohne dass
 * irgendwo eine Medienabfrage nachgezogen werden muesste.
 */
export function Grid({ min = 'md', gap = 4, children, className, ...rest }: GridProps) {
  return (
    <div {...rest} className={`grid ${className ?? ''}`.trim()} data-min={min} data-gap={gap}>
      {children}
    </div>
  );
}
